export enum SettingScreen {
  RECORD_SUMMARY = 1,
  RECORD_LIST = 2,
  RECORD_GRAPH = 3,
  SHARED_INFO = 4,
}

export enum AgreePlanStatus {
  PRIOR_CONSENT = 1,
  WAITING_EXPLANATION = 2,
  REQUESTED = 3,
  AGREED = 6,
}

export enum CarekartePassRole {
  ADMIN = 1,
  STAFF = 2,
  RELATIVE = 3,
  PARTICIPANT = 4,
  SYSTEM_ADMIN = 5,
  DESIGNATED_PERSON = 9,
}

export const PERMISSION_VALUE = {
  OFF: 0,
  ON: 1,
  ALWAYS_ON: 2,
  ALWAYS_OFF: 3,
};

export const PERMISSION_DAI_DIALOG = {
  EDIT: 'EDIT',
  CREATE: 'CREATE',
};

export const EXCLUDE_RP_PERMISSION_KEY = ['RP_PLANNING'];

export const EXCLUDE_PERMISSION_KEY = ['CONSENTER_SETTINGS', 'CONFIRM_AND_CONSENT_PLAN'];

export enum GENDER {
  MALE = 1,
  FEMALE = 2,
}

export enum MASTER_MESSAGE_V2_TYPE {
  NOTIFICATION = 0,
  CONFIRM = 1,
  NOTIFICATION_OK = 2,
}

export enum PostStatus {
  DRAFT = 0,
  FINAL = 1,
}

export const SEND_TARGET_COLOR = {
  green: '#4E9B29',
  lightSeaGreen: '#299B93',
  orange: '#DE651F',
};

export const SEND_TARGET = {
  0: {
    name: 'SEND_TARGET.RELATIVE',
    color: SEND_TARGET_COLOR.green,
    roleId: CarekartePassRole.RELATIVE,
    isDisabled: false,
  },
  1: {
    name: 'SEND_TARGET.PARTICIPANT',
    color: SEND_TARGET_COLOR.lightSeaGreen,
    roleId: CarekartePassRole.PARTICIPANT,
    isDisabled: false,
  },
  2: {
    name: 'SEND_TARGET.DESIGNATED_PERSON',
    color: SEND_TARGET_COLOR.orange,
    roleId: CarekartePassRole.DESIGNATED_PERSON,
    isDisabled: false,
  },
};

export enum CONSENTER_HOME {
  CHANGING_REGISTERED = 0,
  ADD_DAI_AS_CONSENTER = 1,
  ADD_RELATIVE_AS_CONSENTER = 2,
}

export const CONSENTER_HOME_OPTIONS = [
  { name: 'CONSENTER_HOME_OPTIONS.CHANGING_REGISTERED', value: 0 },
  { name: 'CONSENTER_HOME_OPTIONS.ADD_DAI_AS_CONSENTER', value: 1 },
  { name: 'CONSENTER_HOME_OPTIONS.ADD_RELATIVE_AS_CONSENTER', value: 2 },
];

export enum ConsenterScreenType {
  CONTROL_SCREEN = 1,
  RELATIVE_SCREEN = 2,
}

export enum ConsenterPassType {
  DAI_SELF_CARE = 1,
  RELATIVE = 2,
  RELATIVE_WITHOUT_SIGNATURE = 3,
}

export enum DaiRelatedInvite {
  SELF_FAMILY = 0,
  RELATIVE_REGISTER_TEMP = 1,
  RELATIVE_2D_CODE = 2,
  RELATIVE = 3,
  PARTICIPANT = 4,
}

export const IDENTIFY_FLAG_OPTIONS = [
  { name: 'IDENTIFY_FLAG_OPTIONS.DAI', value: 1 },
  { name: 'IDENTIFY_FLAG_OPTIONS.RELATIVE', value: 0 },
];

export enum IDENTIFY_FLAG {
  FAMILY_OR_RELATIVE = 0,
  DAI_SELF_CARE = 1,
}

export enum PASS_FLAG {
  WITHOUT_PASS_ACCOUNT = 0,
  WITH_PASS_ACCOUNT = 1,
}

export enum DAI_RELATED_TYPE {
  RELATIVE = 'RELATIVE',
  NO_PASS_RELATIVE = 'NO_PASS_RELATIVE',
  PARTICIPANT = 'PARTICIPANT',
  REGISTER_TEMP = 'REGISTER_TEMP',
}

export const DAI_RELATED_INVITE_OPTIONS = [
  { name: 'DAI_RELATED_INVITE.SELF_FAMILY', value: DaiRelatedInvite.SELF_FAMILY },
  { name: 'DAI_RELATED_INVITE.RELATIVE', value: DaiRelatedInvite.RELATIVE },
  { name: 'DAI_RELATED_INVITE.PARTICIPANT', value: DaiRelatedInvite.PARTICIPANT },
];

export const DAI_RELATED_INVITE_SUB_OPTIONS = [
  { name: 'DAI_RELATED_INVITE.REGISTER_TEMP_ACCOUNT', value: DaiRelatedInvite.RELATIVE_REGISTER_TEMP },
  { name: 'DAI_RELATED_INVITE.2D_CODE', value: DaiRelatedInvite.RELATIVE_2D_CODE },
];

export const NON_CK_DAI_RELATED_INVITE_OPTIONS = [
  { name: 'COMPANY_ROLE.RELATIVE', value: DaiRelatedInvite.RELATIVE },
  { name: 'COMPANY_ROLE.PARTICIPANT', value: DaiRelatedInvite.PARTICIPANT },
];

export const GLOBALCONSTANTS = {
  SESSION_LOGIN: 'SESSION_LOGIN',
  CONTACT_METHOD_EMAIL: 1,
  CONTACT_METHOD_SMS: 2,
  SKYWAY_EXP_REMINDER: 60 * 5, // 5min
  SKYWAY_EXP_MILESTONE: 60 * 10, // 10min (should set value > SKYWAY_EXP_REMINDER)
  SKYWAY_ID: {
    CK: 'ck',
    NOT_CK: 'nck',
    RELATIVE: 'r',
    PARTICIPANT: 'p',
    COMPANY: 'c',
    DAICD: 'd',
  },
  SKYWAY_MAX_RETRY: 2,
  // DEV_CONSOLE: environment.DEV_CONSOLE_ENV,
  DEFAULT_USE_PLAN: 1,
  USE_PLAN_CK: 1,
  USE_PLAN_NOT_CK: 2,
  FILTER_DAI_OPTION: [
    { name: '（全ての利用者）', value: 0 },
    { name: '記録公開中の利用者', value: 1 },
    { name: '記録非公開の利用者', value: 2 },
  ],
  TERMS_USE: 1,
  TERMS_USE_UNUSER_CAREKARTE: 2,
  POST_TITLE_MAXLENGTH: 255,
  POST_CONTENT_MAXLENGTH: 320,
  RELATIONSHIP: [
    { name: '夫', value: 1 },
    { name: '妻', value: 2 },
    { name: '子', value: 3 },
    { name: '父', value: 4 },
    { name: '母', value: 5 },
    { name: '兄弟', value: 6 },
    { name: '姉妹', value: 7 },
    { name: '孫', value: 8 },
    { name: '甥', value: 9 },
    { name: '姪', value: 10 },
    { name: 'その他', value: 99 },
  ],
  CONSENTER_TYPE: [
    { name: '必要', value: 2 },
    { name: '不要', value: 3 },
  ],
  CONSENT_SCREEN: [
    { name: 'コントロール画面', value: 1 },
    { name: 'Live画面', value: 2 },
  ],
  FILTER_APPLY_OPTION: [
    { name: '（全て）', value: 0 },
    { name: '登録未完了の一覧を確認する', value: 1 },
    { name: '登録完了の一覧を確認する', value: 2 },
    { name: '取消の一覧を確認する（過去3か月）', value: 3 },
  ],
  RELATIVE_TYPE: [
    { name: '家族・親族', value: 0 },
    { name: '利用者本人', value: 1 },
  ],
};

export enum ApplyStatus {
  REGISTER_TEMP = 0,
  REGISTERED = 1,
  APPROVED = 2,
}

export const INFO_SENT_PLAN_PROGRESS = [
  { value: null, name: '（全て表示）' },
  { value: 2, name: '2.説明・同意待ち' },
  { value: 3, name: '3.依頼済・同意待ち' },
  { value: 6, name: '4.同意・交付済' },
  { value: 1, name: '9.事前同意' },
];

export const APPLY_STATUS_OPTION = [
  { value: ApplyStatus.REGISTER_TEMP, name: 'RELATIVE_APPLY.WAIT_REGISTRATION' },
  { value: ApplyStatus.REGISTERED, name: 'RELATIVE_APPLY.WAIT_APPROVAL' },
  { value: ApplyStatus.APPROVED, name: 'RELATIVE_APPLY.LOGIN_POSSIBLE' },
];

export enum ApprovedStatus {
  LOGIN_POSSIBLE = 0,
  TERM_USE_NOT_AGREED = 1,
  NOT_REGISTERED = 2,
}

export const APPROVED_STATUS_OPTION = [
  { value: ApprovedStatus.LOGIN_POSSIBLE, name: 'RELATIVE_APPLY.LOGIN_POSSIBLE' },
  { value: ApprovedStatus.TERM_USE_NOT_AGREED, name: 'RELATIVE_APPLY.TERM_USE_NOT_AGREED' },
  { value: ApprovedStatus.NOT_REGISTERED, name: 'RELATIVE_APPLY.NOT_REGISTERED' },
];

export const REREGISTRATION_APPLY_SUCCESS_KEYS = {
  HAS_PASS: 'REREGISTRATION_HAS_PASS_SUCCESS',
  NO_PASS: 'REREGISTRATION_NO_PASS_SUCCESS',
};

export const DISPLAY_NOTIFY_MENU_PATH = [
  '/control/basic-information',
  '/control/basic-information/apply',
  '/control/help-management',
];

export const SKIP_PERMISSION_MENU_PATH = [
  '/control/change-company',
  '/control/account-management',
  '/control/help-management',
  '/logout',
];

export const BASIC_INFORMATION_EVENT = {
  UPDATE_DAI_LIST: 'UPDATE_DAI_LIST',
  DAI_DELETED: 'DAI_DELETED',
};
